import { render, staticRenderFns } from "./symptom-report-assessment.vue?vue&type=template&id=7b88ad4c&scoped=true&"
import script from "./symptom-report-assessment.vue?vue&type=script&lang=js&"
export * from "./symptom-report-assessment.vue?vue&type=script&lang=js&"
import style0 from "./symptom-report-assessment.vue?vue&type=style&index=0&id=7b88ad4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b88ad4c",
  null
  
)

export default component.exports